module.exports = __webpack_public_path__ + "static/media/microsoft_network.caad6267.ico";